import { wrapNextPage } from '#/utils/next-wrappers/NextPage'
import Loading from './loading'
import Page from './page'

export default wrapNextPage(Page, { Loading })
